import { render } from "./ExchangeRateEditing.vue?vue&type=template&id=b15b9964&ts=true"
import script from "./ExchangeRateEditing.vue?vue&type=script&lang=ts"
export * from "./ExchangeRateEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__